import type { RouteLocationMatch } from "../protocols";
import type { I18nKey } from "~/i18n/types";

export const useGetRouteText = () => {
  const { $tt } = useNuxtApp();

  return (route: RouteLocationMatch) => {
    const fallback = "-";

    if (typeof route.meta.breadcrumb === "string") {
      return $tt(route.meta.breadcrumb as I18nKey);
    }

    const pathSegments = route.path.split("/").filter(Boolean);
    if (pathSegments.length === 0) {
      return fallback;
    }

    const lastPathSegment =
      pathSegments[pathSegments.length - 1]?.replace(/-/g, " ") || fallback;
    return lastPathSegment;
  };
};
